import React, { useState, useEffect } from 'react';
import { db } from '../../firebase/config';
import { collection, query, orderBy, limit, onSnapshot } from 'firebase/firestore';

const SubscriptionErrorMonitor = () => {
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Query the last 50 errors, ordered by timestamp
    const errorsQuery = query(
      collection(db, 'subscription_errors'),
      orderBy('timestamp', 'desc'),
      limit(50)
    );

    // Set up real-time listener
    const unsubscribe = onSnapshot(errorsQuery, (snapshot) => {
      const errorList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        timestamp: doc.data().timestamp?.toDate()?.toLocaleString() || 'Unknown'
      }));
      setErrors(errorList);
      setLoading(false);
    }, (error) => {
      console.error('Error fetching subscription errors:', error);
      setLoading(false);
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="p-4">
        <p className="text-gray-600">Loading error logs...</p>
      </div>
    );
  }

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Subscription Error Monitor</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-2 text-left">Timestamp</th>
              <th className="px-4 py-2 text-left">Email</th>
              <th className="px-4 py-2 text-left">Error Code</th>
              <th className="px-4 py-2 text-left">Error Message</th>
              <th className="px-4 py-2 text-left">User Agent</th>
            </tr>
          </thead>
          <tbody>
            {errors.length === 0 ? (
              <tr>
                <td colSpan="5" className="px-4 py-2 text-center text-gray-500">
                  No errors recorded
                </td>
              </tr>
            ) : (
              errors.map((error) => (
                <tr key={error.id} className="border-t hover:bg-gray-50">
                  <td className="px-4 py-2">{error.timestamp}</td>
                  <td className="px-4 py-2">{error.email}</td>
                  <td className="px-4 py-2">
                    <span className="inline-block px-2 py-1 text-sm rounded-full bg-red-100 text-red-800">
                      {error.errorCode || 'Unknown'}
                    </span>
                  </td>
                  <td className="px-4 py-2">{error.errorMessage}</td>
                  <td className="px-4 py-2">
                    <div className="truncate max-w-xs" title={error.userAgent}>
                      {error.userAgent}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <p className="mt-4 text-sm text-gray-600">
        Showing the last 50 subscription errors. Updates in real-time.
      </p>
    </div>
  );
};

export default SubscriptionErrorMonitor; 